import OEIconCodes from '../../../lib/oe-icon-codes';
import {OETargetMenuDefs} from '../../elements/target-menu/oe-target-menu-defs';
import {OEAlphaBetaProdTypes} from '../oe-proto-model';

export const OESportTargetType = {
    anatomy:        'anatomy'
};

OESportTargetType.all = [
    OESportTargetType.anatomy
];

export const OESportStartSelectionContent = {

    // alpha
    [OESportTargetType.anatomy]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.sportShoulderGirdle,
                        OETargetMenuDefs.humanThighKnee,
                        OETargetMenuDefs.humanHip2,
                        OETargetMenuDefs.humanElbow
                    ]
                }
            ]
        }
    ],

    // beta
    [OESportTargetType.anatomy + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.sportShoulderGirdle,
                        OETargetMenuDefs.humanThighKnee,
                        OETargetMenuDefs.humanHip2,
                        OETargetMenuDefs.humanElbow
                    ]
                }
            ]
        }
    ],

    // prod
    [OESportTargetType.anatomy + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.sportShoulderGirdle,
                        OETargetMenuDefs.humanThighKnee,
                        OETargetMenuDefs.humanHip2,
                        OETargetMenuDefs.humanElbow
                    ]
                }
            ]
        }
    ]
};

OESportStartSelectionContent.modules = [
    {id: OESportTargetType.anatomy, icon: OEIconCodes.sport.anatomyTarget, categories: OESportStartSelectionContent[OESportTargetType.anatomy]},
];

OESportStartSelectionContent.modulesBeta = [
    {id: OESportTargetType.anatomy, icon: OEIconCodes.sport.anatomyTarget, categories: OESportStartSelectionContent[OESportTargetType.anatomy + OEAlphaBetaProdTypes.beta]},
];

OESportStartSelectionContent.modulesProduction = [
    {id: OESportTargetType.anatomy, icon: OEIconCodes.sport.anatomyTarget, categories: OESportStartSelectionContent[OESportTargetType.anatomy + OEAlphaBetaProdTypes.prod]},
];
